import Repository from './Repository';

const resource = '';

export default {
  async getProvinceLatestYear() {
    let url = `${resource}/province_latest_year.json`;
    return await Repository.get(url).catch((e) => {
      console.error(e);
    });
  }
}
